import { LocalizedSectionTitle } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';

interface WidgetProps {
    titleTextKey: Mews.TextKey;
}

export const Widget = ({ children, titleTextKey }: React.PropsWithChildren<WidgetProps>) => (
    <Stack spacing="200" vertical>
        <LocalizedSectionTitle textKey={titleTextKey} />
        {children}
    </Stack>
);
